import getElementSelectors from '../../shares/lib/getElementSelectors';
import { getSDKConfig } from '../../shares/lib/getSDKConfig';
import getCurrentGameSelected from '../../shares/lib/currentGameSelected';
import { isTenantFeatureEnabled } from '../../shares/helpers/tenantFeatureHelper';
import { TenantFeature } from '../../shares/enums/tenantFeatures';

export const applyGameGradient = (iconPositionClass?: string): void => {
  if (!isTenantFeatureEnabled([TenantFeature.DYNAMIC_GRADIENT])) {
    return;
  }

  const { gradientLayer, swipeHandle } = getElementSelectors();
  if (!gradientLayer) return;

  const isIconAtClosedPosition = iconPositionClass
    ? swipeHandle?.classList.contains(iconPositionClass)
    : false;

  if (isIconAtClosedPosition) {
    gradientLayer.style.background = '#24e676';
    return;
  }

  const { currentGameId } = getCurrentGameSelected();
  const swipeSDKConfig = getSDKConfig();
  const gameListData =
    swipeSDKConfig?.swipeGames?.gameListConfig?.gameList ?? [];
  const selectedGame = gameListData.find(
    (game) => game.gameId.toString() === currentGameId,
  );

  const colorGradient = selectedGame?.colorGradient;
  if (!Array.isArray(colorGradient)) {
    localStorage.removeItem('swipe_game_gradient');
    return;
  }

  const validColors = colorGradient.filter(
    (color) => typeof color === 'string' && color.trim() !== '',
  );

  if (validColors.length < 2) {
    localStorage.removeItem('swipe_game_gradient');
    return;
  }

  localStorage.setItem('swipe_game_gradient', JSON.stringify(validColors));
  const [color1, color2] = validColors;
  gradientLayer.style.background = `linear-gradient(90deg, ${color2} 0%, ${color1} 30%, #24e676 60%, #24e676 100%)`;
};
